import {makeStyles} from "@material-ui/core/styles";
import Modal from "../generales/ModalCerrarActualiza";
import {useEffect, useState} from "react";
import {FormControl, Grid, InputLabel, Box, MenuItem, Select, TextField} from "@material-ui/core";
import qs from "qs";
import {ErrorGeneral, llamaApiCargaToken, llamadaApiToken} from "../funciones/ClienteAxios";
import Autocomplete from "@material-ui/lab/Autocomplete";
import moment from "moment/moment";
import {DatePicker, MuiPickersUtilsProvider} from "@material-ui/pickers";
import DateFnsUtils from '@date-io/date-fns';
import esLocale from "date-fns/locale/es";
import {toast} from "react-toastify";
import SelectEdo from '../generales/SelectEdo';
import { obtenDispo } from '../funciones/IdDispositivo';
const useStyles = makeStyles((theme) => ({}));

const ModalAgregarRecorrido = ({abrirModal, setAbrirModal, idusu, history, source, latitud, longitud,actualiza}) => {

    const classes = useStyles();
    let usuTipo = localStorage.getItem('Tipo');
    let fecha = Date.now()
    const auxDispV =obtenDispo() 
    const usuId =localStorage.getItem('UsuId') ;    
    const [selectedDate, handleDateChange] = useState(fecha);
    const [listDistrito, setListDistrito] = useState([])
    const [auxListSecc, setAuxListSecc] = useState([])
    const [listTipo, setListTipo] = useState([])
    const [espera,setEspera]= useState(false);
    const [nuevoRegistro, setNuevoRegistro] = useState({
        Estado: process.env.REACT_APP_EDO,
        Municipio: '',
        Seccion: '',
        Tipo: '',
        Latitud: latitud,
        Longitud: longitud,
        Fecha: '',
        Direccion: '',
        Observacion: '',
        Distrito:"",
        Cantidad:"",
    });
    const {Distrito, Municipio, Seccion, Tipo, Longitud, Latitud, Fecha, Direccion, Observacion, Cantidad} = nuevoRegistro
    const [btnDeshabilitado, setBotonDeshabilitado] = useState(false)
    const [aviso, setAviso] = useState(false);
    const [mensaje, setMensaje] = useState("");
    const [tipoAdvertencia, setTipoAdvertencia] = useState("success");
    const [cargando, setCargando] = useState(false);
    const [listSecc, setListSecc]= useState([]);  

    const handleClose = () => {
        setAbrirModal(false)
        setAviso(false);
    }

    useEffect(() => {
        getListDto()
        if (listTipo.length === 0) {
            recuperarTipo()
        }
    }, []);

    function getListDto()  {            
        const url= `lugar/municipio/distrito`;                            
        const data = qs.stringify({                
            Usuario:idusu,              
            Estado:process.env.REACT_APP_EDO,                                                
            ip:"127.0.0.0",
            idDispositivo:auxDispV,
        });
                    
        function respuesta (aux) 
        {   if (aux[0].Id != -1) 
            {   
                let listNvo=[]
                aux.forEach(element => {
                    listNvo.push({...element, cadena:`D${element.Nom} - ${element.ComNom}`})
                });
                setListDistrito(listNvo) 
                //filtroMun(aux)               
            }  
            else{
                setListDistrito([])
            }                                                                    
        }
        llamadaApiToken(data, url, respuesta, ErrorGeneral, history, source);
    };

    const getListSecc = (auxDto) => {
        const data = qs.stringify({
            Usuario: usuId, Distrito:auxDto,  Estado:process.env.REACT_APP_EDO, ip:"127.0.0.0", idDispositivo: auxDispV,
        });
        const url = "lugar/v2/seccion/distrito";

        function respuestaSecc(auxiliar) {
            if (auxiliar[0].Num != -1 && auxiliar[0].Num != "-1") {               
                
                setListSecc(auxiliar)                
            }
        }

        llamaApiCargaToken(data, url, respuestaSecc, ErrorGeneral, setEspera, history, source);
    }
            

    const recuperarTipo = () => {
        const data = qs.stringify({
            Usuario: idusu,
            idDispositivo: auxDispV
        });
        const url = "recorrido-tipo";

        function respuesta(response) {
            if (response[0].Id != -1) {
                setListTipo(response)
            }
        }

        llamaApiCargaToken(data, url, respuesta, ErrorGeneral, setCargando, history, source);
    };

    const onChangeDto = (e) => {
        if (e !== null && e !== undefined) {
            getListSecc( e.target.value)
            setNuevoRegistro({
                ...nuevoRegistro,
                Distrito: e.target.value,Seccion:""
            })
            setMensaje('');
            setAviso(false);
        } else {
            setNuevoRegistro({
                ...nuevoRegistro,
                Distrito: "",Seccion:""
            })
        }
    }

    const onChange = e => {
        setNuevoRegistro({...nuevoRegistro,[e.target.name]: e.target.value})
    }

        const onChangeSel=(e)=>{
        if (e!== null && e!== undefined) 
        {  setNuevoRegistro({...nuevoRegistro,[e.target.name] : e.target.value})
        }else
        {setNuevoRegistro({...nuevoRegistro,[e.target.name] : 0})
        } 
        
    }


    const guardarRecorrido = () => {
        setCargando(true)
       // setBotonDeshabilitado(true);

        const data = qs.stringify({
            Usuario: idusu,
            Edo: process.env.REACT_APP_EDO,
            Muni: process.env.REACT_APP_MUN,
            Seccion: Seccion,
            fecha: moment(selectedDate).format("YYYY-MM-DD") + 'T00:00:00',
            latitud: Latitud,
            longitud: Longitud,
            AntLat:0.0,
            AntLon:0.0,
            ManualDir:"",
            Cantidad:Cantidad,
            Tipo: Tipo,
            Direccion: Direccion,
            Observ: Observacion,
            Manual:1,
            idDispositivo: auxDispV
        });

        const url = "recorrido/v5/new";

        function respuesta(response) {
            if (response.respuesta === 1) {
                setAviso(true)
                toast.success('Recorrido agregado correctamente', {
                    pauseOnFocusLoss: false,
                    toastId: `nvo-recorrido${1}`
                })
                actualiza()
                setAbrirModal(false)
            } else {
               // setBotonDeshabilitado(false);
                toast.error('Datos incorrectos, intente mas tarde', {
                    pauseOnFocusLoss: false,
                    toastId: `error-recorrido${1}`
                })
            }
        }

        llamaApiCargaToken(data, url, respuesta, ErrorGeneral, setCargando, history, source);
    }

    const verificaNulos = (campo,descripcion)=>{
        let respuesta =false;        
          
        if( (typeof campo !== 'number' && typeof campo === 'string' 
            && (campo.trim() === '' || campo.trim() === null) )
        ) 
        {   respuesta=true;        
          //  console.log(campo+' '+descripcion);                  
            setMensaje('No se lleno el campo '+descripcion);
            setTipoAdvertencia("warning")  
            setAviso(respuesta);
        }
        return(respuesta);
    }

    function guardarDatos(e) {
        e.preventDefault()
        if ( !verificaNulos(Distrito,"Distrito") && 
            !verificaNulos(Seccion,"Sección") && 
            !verificaNulos(Tipo,"Tipo") && 
             !verificaNulos(Cantidad,"Cantidad") &&
            !verificaNulos(Direccion,"Dirección") ) 
        {   //console.log("prueba",nuevoRegistro);
            setAviso(false);
            guardarRecorrido()
           // console.log( moment(selectedDate).format("YYYY-MM-DD") + 'T00:00:00');
        }  
    }

    return (
    <Modal
        titulo={'Nuevo Registro'} modalAbierto={abrirModal} mensaje={mensaje}
        setModalAbierto={setAbrirModal} guardarDatos={guardarDatos}
        tipoAdvertencia={tipoAdvertencia} aviso={aviso} tamanio={'sm'}
        btnDeshabilitado={btnDeshabilitado} setAviso={setAviso}
        cargando={cargando} cerrarBorrar={handleClose}
    >
        <Grid container alignItems={'center'} spacing={1}>
    
            <Grid item xs={4}>
                {listDistrito.length !== 0 ?
                    <FormControl size='small'>
                        <InputLabel size='small' variant="outlined" id="Distrito-label-nvo">Distrito</InputLabel>
                        <Select size='small' variant="outlined" style={{width: '10rem'}}
                            label="Distrito" id="Distrito-select2" name="Distrito"
                            value={Distrito} onChange={onChangeDto}
                            fullWidth
                        >
                            {listDistrito.map((dto, index) => {
                                return (
                                <MenuItem size='small' value={dto.Id} key={dto.Id}>
                                    <em>{dto.Nom}</em>
                                </MenuItem>
                                )
                                }
                            )}
                        </Select>
                    </FormControl>
                    : <FormControl size='small'>
                        <InputLabel size='small' variant="outlined" id="Distrito-label-nvo">Distrito</InputLabel>
                        <Select size='small' variant="outlined" style={{width: '10rem'}} 
                            label="Distrito" id="Distrito-select2" name="Distrito"
                            value={Distrito} onChange={onChangeDto}
                            fullWidth
                        >
                            <MenuItem size='small' value={''}>
                                <em></em>
                            </MenuItem>
                        </Select>
                    </FormControl>
                }
            </Grid>
            <Grid item xs={4} >
                { listSecc.length!==0 ?                
                <Box display={"flex"} mb={1}>
                <FormControl size='small'  style={{ minWidth:10+'rem', marginLeft:".5rem"}} >
                    <InputLabel size='small' variant="outlined" id="Seccion-label-nvo">Sección</InputLabel>
                    <Select  size='small' variant="outlined"  
                        label="Sección" id="Seccion-select2" name="Seccion"
                        value={Seccion} onChange={onChangeSel}
                    >
                        {listSecc.map((secc, index) => {
                            
                            return(
                            <MenuItem size='small' value={secc.Id} key={secc.Id}>
                                <em>{`${secc.Num} ` }</em>
                            </MenuItem>
                            )
                        } )}                    
                    </Select>
                    </FormControl>
                    </Box>
                :   null 
                }
            </Grid>
            <Grid item xs={4}>
                <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                    <DatePicker
                        disableFuture label="Fecha"
                        format="dd/MM/yyyy" size="small"
                        views={["year", "month", "date"]}                                                
                        minDate="2017-03-14" maxDate={new Date()}
                        value={selectedDate} onChange={handleDateChange}
                        style={{width: 7.5 + 'rem', paddingBottom:".6rem"}}
                    />
                </MuiPickersUtilsProvider>
            </Grid>
            <Grid item xs={6}>
                {listTipo.length !== 0 ?
                <FormControl size="small">
                    <InputLabel htmlFor="Tipo" variant="outlined"  >Tipo</InputLabel>
                    <Select native value={Tipo} fullWidth onChange={onChange} variant="outlined"  
                        inputProps={{name: 'Tipo', id: 'Tipo',}} style={{width:"15rem"}}
                    >
                        {listTipo.map(element => {
                            return <option key={element.Id} value={element.Id}>
                                {element.Nom}</option>
                        })}
                    </Select>
                </FormControl>
                : null
                }
            </Grid>
          
            <Grid item xs={4} style={{marginBottom:.5+'rem',marginTop:.5+'rem'}}>
                <TextField id="Cantidadtxt" name="Cantidad" label="Cantidad" fullWidth size="small"
                    type="number"
                    value={Cantidad} onChange={onChange} variant="outlined"/>
            </Grid>
   
            <Grid item xs={12} style={{marginBottom:.5+'rem',marginTop:.5+'rem'}}>
                <TextField id="Direccion" name="Direccion" label="Dirección" fullWidth size="small"
                    value={Direccion} onChange={onChange} variant="outlined"/>
            </Grid>
            <Grid item xs={12}>
                <TextField
                    id="Observacion" name="Observacion"
                    label="Observación" variant="outlined"
                    multiline fullWidth onChange={onChange}
                    rows={4} value={Observacion}
                />
            </Grid>
        </Grid>
    </Modal>);
};

export default ModalAgregarRecorrido;
